<div class="stepper-wrapper">
  <p-stepper [value]="1" class="basis-[50rem]">
    <p-step-list>
      <p-step [value]="1" [disabled]="true">Seleccionar Equipos</p-step>
      <p-step [value]="2" [disabled]="true">Procesar Programación</p-step>
    </p-step-list>
    <p-step-panels>
      <p-step-panel [value]="1">
        <ng-template #content let-activateCallback="activateCallback">
          <div class="container-style">
            <div class="panel-content">
              <div class="flex flex-col">
                <app-custom-table #customTable [showRecover]="true" [showCheckbox]="true" [isMultipleSelect]="true"
                  [showButtonAdd]="false" [data]="dataArticle" [headers]="header" [previousFilters]="filters"
                  [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getArticlesForSelection()"
                  (selectionChange)="selectionChange($event)" (onPageChange)="onPageChange($event)"
                  (onFilterChange)="onFilterChange($event)">
                </app-custom-table>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end mt-2">
            <app-custom-button [width]="'6.5'" [severity]="'contrast'" [label]="'Siguiente'"
              [icon]="'pi pi-arrow-right'" (onClick)="goToStep(2, activateCallback)">
            </app-custom-button>
          </div>
        </ng-template>
      </p-step-panel>
      <p-step-panel [value]="2">
        <ng-template #content let-activateCallback="activateCallback">
          <div class="row container-style">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-between align-items-center">
              <div class="d-flex gap-4 ps-2">
                <div>
                  <label class="text-muted small d-block">Sucursal</label>
                  <span class="fw-bold">
                    {{maintenanceSchedulingModel.branchId }}
                  </span>
                </div>
                <div>
                  <label class="text-muted small d-block">Programación</label>
                  <span class="fw-bold">
                    {{maintenanceSchedulingModel.consecutive}}
                  </span>
                </div>
                <div>
                  <label class="text-muted small d-block">Fecha</label>
                  <span class="fw-bold text-uppercase">
                    {{maintenanceSchedulingModel.dateMaintenanceScheduling | date: 'dd/MM/yyyy'}}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="row container-style mt-2" *ngIf="showPreinvoicingProgress">
            <h6><b>Procesando...</b></h6>
            <app-custom-progress-bar class="mt-1" [show]="true" [heightProgress]="'0.8rem'"></app-custom-progress-bar>
          </div>
          <div id="container-liquidation" *ngIf="visiblePdf" class="row container-style mt-2 ">
            <div id="list">
              <div class="d-flex justify-content-between">
                <p class="mb-2"><b class="style-text">Lista de Errores y Alertas</b></p>
                <app-custom-button [title]="'Exportar'" [label]="'Exportar'" [icon]="'pi pi-file-export'"
                  [width]="'5.5rem'" (onClick)="downloadErrorsTxt()"></app-custom-button>
              </div>
              <hr class="my-2">
              <div id="container-alerts" *ngFor="let preInvoicingAlert of processAlerts">
                <p [ngClass]="errorProcess == 1 ? 'text-danger' : ''">
                  {{preInvoicingAlert.message}}
                </p>
              </div>
            </div>
          </div>
          <div class="row justify-content-between mt-2">
            <div class="d-flex justify-content-between">
              <app-custom-button [width]="'6.5'" [label]="'Regresar'" [severity]="'contrast'"
                [icon]="'pi pi-arrow-left'" (onClick)="goToStep(1, activateCallback)">
              </app-custom-button>

              <app-custom-button [title]="'Iniciar'" [label]="'Iniciar'" [disabled]="disabledStart"
                (onClick)="processMaintenanceScheduling()"></app-custom-button>
            </div>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-panels>
  </p-stepper>
</div>